import {noop} from 'lodash';
import {createContext, useContext} from 'react';

import {TeamModel} from '../../../../../libs/shared/core/src/models/api/teamModel';
import {AdminSetupGuideScreensEnum} from '../../../onboarding/adminSetupGuide/adminSetupGuideTypes';

export enum ContinueSetupTipsEnum {
  COMPLETED_SHARED_WORKSPACE = 'completed_shared_workspace',
  CONNECT_CHANNEL = 'connect_channel',
  INVITE_TEAMMATES = 'invite_teammates',
}

export interface OnboardingModalContextProps {
  isAdminSetupGuideOpen: boolean;
  defaultAdminSetupGuideScreen: AdminSetupGuideScreensEnum;
  openAdminSetupGuide: () => void;
  openAdminSetupGuideDemoScreen: () => void;
  openAdminSetupGuideSetupScreen: () => void;
  closeAdminSetupGuide: () => void;

  isOnboardingChecklistModalOpen: boolean;
  setIsOnboardingChecklistModalOpen: (arg: boolean) => void;
  shouldOpenOnboardingChecklist: () => boolean;
  /** @returns Whether the onboarding checklist was opened. */
  maybeOpenOnboardingChecklist: () => boolean;
  // Adding settingsSelectedTeam and setSettingsSelectedTeam to the onboarding hooks for now,
  // as they're part of the onboarding project experiment. If we decide to keep them long term,
  // we should move them to their own context/provider.
  settingsSelectedTeam: TeamModel | undefined;
  setSettingsSelectedTeam: (team: TeamModel | undefined) => void;

  isAdminWizardOpen: boolean;
  setIsAdminWizardOpen: (arg: boolean) => void;

  requestedContinueSetupTip: ContinueSetupTipsEnum | undefined;
  requestContinueSetupTip(continueSetupTip: ContinueSetupTipsEnum): void;
  clearRequestedContinueSetupTip(): void;
}

export const OnboardingModalContext = createContext<OnboardingModalContextProps>({
  isAdminSetupGuideOpen: false,
  defaultAdminSetupGuideScreen: AdminSetupGuideScreensEnum.DEFAULT,
  openAdminSetupGuide: noop,
  openAdminSetupGuideDemoScreen: noop,
  openAdminSetupGuideSetupScreen: noop,
  closeAdminSetupGuide: noop,
  isOnboardingChecklistModalOpen: false,
  setIsOnboardingChecklistModalOpen: noop,
  shouldOpenOnboardingChecklist: () => false,
  maybeOpenOnboardingChecklist: () => false,
  settingsSelectedTeam: undefined,
  setSettingsSelectedTeam: noop,
  isAdminWizardOpen: false,
  setIsAdminWizardOpen: noop,
  requestedContinueSetupTip: undefined,
  requestContinueSetupTip: noop,
  clearRequestedContinueSetupTip: noop,
});

export function useOnboardingModalState() {
  return useContext(OnboardingModalContext);
}
